import { type FC } from 'react'
import { type BookingClient } from '../../../models/Scheduling'
import { unsubscribeNoticeText } from './clientUnsubscribes'

interface ClientUnsubscribeNoticeProps {
  unsubscribed: BookingClient[]
  clients: BookingClient[]
}

export const ClientUnsubscribeNotice: FC<ClientUnsubscribeNoticeProps> = ({ unsubscribed, clients }) => {
  if (unsubscribed.length === 0) {
    return null
  }
  return (
    <div role='status' aria-live='polite' className='d-flex align-items-start zocks-gap-0.5 paragraph-small zocks-text-gray-600'>
      <i className='bi bi-exclamation-triangle-fill zocks-text-warning-dark flex-shrink-0' aria-hidden='true' />
      <span>{unsubscribeNoticeText({ unsubscribed, clients })}</span>
    </div>
  )
}
